'use client';

import { useEffect, Suspense } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import { getPostHogClient } from '@/lib/analytics/posthog';

function PostHogPageTracker() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    getPostHogClient();
  }, []);

  useEffect(() => {
    const posthog = getPostHogClient();
    if (!posthog) return;

    let url = window.origin + pathname;
    const qs = searchParams.toString();
    if (qs) url += '?' + qs;

    posthog.capture('$pageview', { $current_url: url });
  }, [pathname, searchParams]);

  return null;
}

export function PostHogProvider({ children }: { children: React.ReactNode }) {
  return (
    <>
      <Suspense fallback={null}>
        <PostHogPageTracker />
      </Suspense>
      {children}
    </>
  );
}
